
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Product, SizeGuide } from "@/types/product";

export const useProducts = () => {
  console.log("🔍 HOOK USE_PRODUCTS: Début de la requête");
  
  return useQuery({
    queryKey: ["products"],
    queryFn: async () => {
      console.log("📥 REQUÊTE PRODUITS: Démarrage");
      
      // Afficher les produits dans la console pour debug
      const { data: allProducts } = await supabase
        .from('products')
        .select('name, published')
        .eq('published', true);
      
      console.log("🔎 TOUS LES PRODUITS PUBLIÉS:", allProducts?.map(p => p.name));
      
      const { data, error } = await supabase
        .from('products')
        .select(`
          id,
          name,
          description,
          price,
          published,
          has_sizes,
          has_colors,
          has_size_guide,
          size_guide,
          slug,
          product_categories!product_categories_product_id_fkey (
            categories!inner (
              name
            )
          ),
          product_variants!product_variants_product_id_fkey (
            id,
            size,
            color_name,
            color_hex,
            position
          ),
          product_images!product_images_product_id_fkey (
            url,
            main
          )
        `)
        .eq('published', true)
        .order('created_at', { ascending: false });

      if (error) {
        console.error("❌ ERREUR RÉCUPÉRATION PRODUITS:", error);
        throw error;
      }

      console.log("📊 NOMBRE DE PRODUITS BRUTS:", data?.length);
      
      // Parcourir chaque produit pour vérifier les détails
      data?.forEach(product => {
        console.log(`📦 PRODUIT: ${product.name}`, {
          id: product.id,
          slug: product.slug,
          catégories: product.product_categories?.map((pc: any) => pc.categories?.name),
          variants: product.product_variants?.length,
          images: product.product_images?.map((img: any) => img.url)
        });
      });

      const mappedProducts = data.map((product): Product => {
        console.log(`🔄 Transformation du produit ${product.id}:`, product);
        
        // Récupérer les catégories directement de la base de données
        const categories = product.product_categories
          ? product.product_categories.map((pc: any) => pc.categories.name)
          : [];
          
        // Trier les variants par position
        const sortedVariants = [...product.product_variants].sort((a, b) => 
          (a.position || 0) - (b.position || 0)
        );
          
        return {
          id: product.id,
          name: product.name,
          description: product.description,
          price: product.price,
          categories: categories,
          published: product.published,
          has_sizes: product.has_sizes,
          has_colors: product.has_colors,
          has_size_guide: product.has_size_guide,
          size_guide: product.size_guide as SizeGuide | null,
          slug: product.slug,
          variants: sortedVariants.map((variant: any) => ({
            size: variant.size,
            colorName: variant.color_name,
            colorHex: variant.color_hex,
            position: variant.position
          })),
          images: product.product_images.map((image: any) => {
            // Corriger les URL d'images
            let imageUrl = image.url;
            if (imageUrl && imageUrl.startsWith('public/')) {
              imageUrl = imageUrl.replace('public/', '/');
            }
            return imageUrl;
          })
        };
      });

      console.log("✅ REQUÊTE PRODUITS: Terminée");
      return mappedProducts;
    },
    staleTime: 0, // Ne pas mettre en cache pour forcer le rafraîchissement
    refetchOnWindowFocus: true, // Recharger quand la fenêtre reprend le focus
    refetchOnMount: true, // Recharger à chaque montage
    retry: 2 // Réessayer en cas d'échec
  });
};
